export enum EntityStoreKey {
  TellentMembers = 'TellentMembers',
  TellentApps = 'TellentApps',
}

export type TransferOwnershipPayload = {
  memberGuid: string;
  code: string;
};
